// extracted by mini-css-extract-plugin
export default {"avatarRow":"UserDetailsPage_avatarRow__Tope2","avatar":"UserDetailsPage_avatar__5WdZq","buttonRow":"UserDetailsPage_buttonRow__Z7qyk"};